<template>
  <section
    class="property-photos-section"
    :class="{ branded: branded }"
  >
    <property-photos-modal
      v-if="showingGalleryModal"
      :class="{ branded: branded }"
      :initial-slide="galleryModalInitialSlide"
      :property="property"
      @click-close="closeGalleryModal"
    />
    <swiper
      :centered-slides="true"
      :lazy="{checkInView: true, loadPrevNext: true}"
      :loop="true"
      :navigation="true"
      :pagination="{type: 'fraction'}"
      :slides-per-view="'auto'"
      :space-between="24"
      :swiper-pagination-clickable="true"
    >
      <swiper-slide
        v-for="(photo, i) in filteredPhotos"
        :key="photo.media_key"
        class="cursor-pointer bg-gray-600"
        @click="showGalleryModal(i)"
      >
        <!--suppress RequiredAttributes -->
        <img
          :alt="photo.short_description || 'Missing photo description'"
          class="swiper-lazy bg-gray-600"
          :data-src="photo.media_url"
        >
        <div
          class="swiper-lazy-preloader swiper-lazy-preloader-white bg-gray-600"
        />

        <div
          class="
          absolute text-white text-shadow bottom-0 right-0 w-48 h-48
          bg-gradient-to-tl via-transparent from-black"
        >
          <font-awesome-icon
            class="absolute bottom-5 right-5"
            :icon="['fas', 'compress']"
          />
        </div>
      </swiper-slide>
    </swiper>
  </section>
</template>

<script>
import { faCompress } from '@fortawesome/free-solid-svg-icons/faCompress';
import { library } from '@fortawesome/fontawesome-svg-core';

import SwiperCore, { Navigation, Lazy, Pagination } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/vue';

import getPropertyPhotos from '../helpers/getPropertyPhotos';
import PropertyPhotosModal from './PropertyPhotosModal.vue';

export default {
  name: 'PropertyPhotos',

  components: {
    PropertyPhotosModal,
    Swiper,
    SwiperSlide,
  },
  props: {
    branded: {
      required: true,
      type: Boolean,
    },
    property: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      showingGalleryModal: false,
      galleryModalInitialSlide: 0,
    };
  },

  computed: {
    /** @type {array} */
    filteredPhotos() {
      return getPropertyPhotos(this.property);
    },
  },

  created() {
    library.add(faCompress);

    SwiperCore.use([
      Navigation, Lazy, Pagination,
    ]);
  },

  methods: {
    showGalleryModal(imageIndex) {
      this.showingGalleryModal = true;
      this.galleryModalInitialSlide = imageIndex;
    },
    closeGalleryModal() {
      this.showingGalleryModal = false;
    },
  },

  display({ property }) {
    return getPropertyPhotos(property).length > 0;
  },
};
</script>

<!--suppress CssUnusedSymbol -->
<style lang="scss">
@use "sass:math";
@import "~swiper/swiper.min.css";
@import "~swiper/components/navigation/navigation.min.css";
@import "~swiper/components/lazy/lazy.min.css";

.property-photos-section {
  $width: 73%;
  > .swiper-container {
    width: 100%;
    height: 100%;
    padding: 44px 0;
    margin-bottom: 44px;
    @screen xl {
      margin-bottom: 114px;
    }

    // Pagination
    position: relative;
    .swiper-pagination {
      position: absolute;
      bottom: 0;
      width: $width;
      margin-left: math.div(100% - $width,2);
      text-align: right;
      @apply text-secondary text-sm text-xl px-2;
    }

    // Navigation
    .swiper-button-prev,
    .swiper-button-next {
      text-shadow: #000 0 3px 4px;
      display: none;
      @screen xl {
        display: block;
      }
    }

    .swiper-button-prev {
      left: 60px;
    }

    .swiper-button-next {
      right: 60px;
    }

    // Slide
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;

      width: $width;

      img {
        display: block;
        width: 100%;
        height: 100%;
        max-height: 700px;
        object-fit: cover;
        aspect-ratio: 780 / 662;
      }
    }

  }
}

:root {
  --swiper-navigation-color: #fff;
}
.branded {
  .swiper-button-next, .swiper-button-prev {
    --swiper-navigation-color: theme('colors.secondary');
  }
}
</style>
